import React from "react";

import Box from "@mui/material/Box";
import { useQuery } from "@tanstack/react-query";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import {
  EpisodesIcon,
  ProjectsFolderIcon,
  ShareNetworkIcon,
  ClockIcon,
} from "../common/icons";
import AppLayout from "../common/AppLayout";
import CardView from "./components/Card";
import EpisodesList from "./components/EpisodesList";
import { dashboardService } from "./services";
import { BRAND_COLORS } from "../../constants";

export default function DashboardView() {
  const globalTheme = useTheme();
  const mobile = useMediaQuery(globalTheme.breakpoints.down("md"));

  const { data } = useQuery({
    queryKey: ["dashboard-stats"],
    queryFn: () => dashboardService.fetchDashboardStats(),
  });

  const { data: projectData, refetch: refetchProjects } = useQuery({
    queryKey: ["projects"],
    queryFn: () => dashboardService.fetchProjects(),
  });

  const stats = [
    {
      title: "Projects",
      value: data?.number_of_projects ?? 0,
      description: "Active projects",
      Icon: ProjectsFolderIcon,
      color: BRAND_COLORS.primary,
      disabled: false,
    },
    {
      title: "Total Minutes",
      value: data?.total_episodes_length_in_minutes ?? 0,
      description: "Content uploaded",
      Icon: ClockIcon,
      color: "#f59e0b",
      disabled: false,
    },
    {
      title: "Episodes",
      value: data?.number_of_episodes ?? 0,
      description: "Published episodes",
      Icon: EpisodesIcon,
      color: "#10b981",
      disabled: false,
    },
    {
      title: "Shared",
      value: data?.number_of_shared_projects ?? 0,
      description: "Shared with others",
      Icon: ShareNetworkIcon,
      color: "#8b5cf6",
      disabled: true,
    },
  ];

  return (
    <AppLayout pageName="Episodes" maxWidth={false}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        {/* Stats cards row */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: mobile ? "1fr 1fr" : "repeat(4, 1fr)",
            gap: 2,
          }}
        >
          {stats.map((stat) => (
            <CardView
              key={stat.title}
              Icon={stat.Icon}
              title={stat.title}
              value={stat.value}
              description={stat.description}
              color={stat.color}
              disabled={stat.disabled}
            />
          ))}
        </Box>

        {/* Episodes list */}
        <EpisodesList
          projects={projectData?.projects}
          refetchProjects={refetchProjects}
        />
      </Box>
    </AppLayout>
  );
}
